import { Component, effect, signal, OnDestroy } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { LocalstorageService } from '../services/localstorage.service';
import { NgClass } from '@angular/common';
import { LogoComponent } from '../logo/logo.component';
import { TwoFactorService } from '../services/two-factor.service';
import { TwoFactorSetupComponent } from '../two-factor-setup/two-factor-setup.component';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AppConfig } from '../../environments/environment';



@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    MatInputModule,
    MatButtonModule,
    FormsModule,
    NgClass,
    LogoComponent,
    TwoFactorSetupComponent,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnDestroy {

  login: string = '';
  password: string = '';

  open = signal(0);

  showLogin = false;
  showActivation = false;
  destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private localstorageService: LocalstorageService,
    private authService: AuthService,
    private twoFactorService: TwoFactorService,
  ) {

    this.twoFactorService.generate2fa$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.showActivation = true;
      });

    effect(() => {
      const value: number = this.open();
      if (value === 25) {
        this.showLogin = true;
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }


  auth() {
    this.authService.login(this.login, this.password)
      .subscribe((res) => {
        if (res) {
          this.localstorageService.set('token', res.token);

          // load license information and store
          this.authService.loadLicense(this.login, this.password)
            .subscribe({
              next: () => {
                this.check2FA();
              },
              error: () => {
                // Even if license fails, continue – form может потребовать лицензию позже
                this.check2FA();
              }
            });
        }
      })
  }

  check2FA() {
    // Check if we're in development mode - bypass 2FA
    if (!AppConfig.production) {
      console.log('Development mode detected - bypassing 2FA');
      this.router.navigateByUrl('/search');
      return;
    }

    // In production mode, trigger 2FA
    console.log('Production mode - requiring 2FA');
    this.twoFactorService.generate2fa$.next();
  }

  openMy(num: number) {
    this.open.update((value: number) => value + num);
  }
}
